define('gameday-index-gdtracking/src/OmnitureGamedayPage',['require','exports','module','jquery','tracking/omniture'],function(require,exports,module){
    var $ = require('jquery'),
        OmnitureFactory = require( "tracking/omniture" ),
        Omniture = OmnitureFactory.Omniture;

    function OmnitureGamedayPage(props){
        // Do some init directly on the s object;
        window.s.pageName  = "";
        window.s.channel   = "";
        window.s.campaign  = "";
        window.s.prop1 = "";
        Omniture.call(this,props);
        
        this.addEvents('event4');
    }

    OmnitureFactory.create(OmnitureGamedayPage);

    return OmnitureGamedayPage
}); 
